//Mixins
import { mapMixins } from "@/mixins/mapMixins";
import { ordermixins } from "@/mixins/ordermixins";

export const unassignedordermixins = {
    mixins: [mapMixins, ordermixins],
    props: {
        assignorder: {
            type: Object,
            default: () => null,
        },
        showAssignPop: {
            type: Boolean,
            default: () => false,
        },
        group: {
            type: Object,
            default: () => null,
        },
        order: {
            type: Object,
            default: () => null,
        },
        assignedorderids: {
            type: Array,
            default: () => [],
        },
    },
}